import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api, errorMessage } from "../api/client";

export type Onboarding = {
  wizard: { completed: boolean; step: "company" | "site" | "team" | "modules" | "done"; modules: string[] };
  checklist: { key: string; label: string; href: string; done: boolean }[];
  dismissed: boolean;
};

export function useOnboarding() {
  return useQuery({
    queryKey: ["onboarding"],
    queryFn: async () => {
      const { data, error } = await api.GET("/api/v1/accounts/onboarding/");
      if (error) throw new Error(errorMessage(error));
      return data as unknown as Onboarding;
    },
  });
}

export function useSaveStep() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: { step: Onboarding["wizard"]["step"]; payload: Record<string, unknown> }) => {
      const { data, error } = await api.PUT("/api/v1/accounts/onboarding/", { body: input as never });
      if (error) throw new Error(errorMessage(error));
      return data as unknown as Onboarding;
    },
    onSuccess: (data) => { qc.setQueryData(["onboarding"], data); void qc.invalidateQueries({ queryKey: ["me"] }); void qc.invalidateQueries({ queryKey: ["dashboard"] }); },
  });
}
